import React from "react";
import { ArrowLeft } from "lucide-react";
import { DECLINE_CATEGORY_LABELS } from "../AdminBookings/declineOptions";

const CATEGORY_STYLES = {
  CUSTOMER_FAULT: { color: "text-rose-600", bg: "bg-rose-100" },
  EMPLOYEE_FAULT: { color: "text-amber-600", bg: "bg-amber-100" },
  ADMIN_FAULT: { color: "text-sky-600", bg: "bg-sky-100" },
  UNSPECIFIED: { color: "text-gray-600", bg: "bg-gray-200" },
};

const DeclineBreakdownCards = ({
  declineCategoryCounts = {},
  declinedByEmployeeCount = 0,
  onDeclinedByEmployeeClick,
  onCategoryClick,
  onViewAll,
  onBack,
}) => {
  const totalDeclined = Object.values(declineCategoryCounts).reduce(
    (sum, c) => sum + (c || 0),
    0,
  );

  return (
    <div className="w-full p-6 space-y-6">
      <div className="flex justify-between items-center">
        <button
          onClick={onBack}
          className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white text-black shadow hover:bg-gray-100 transition"
        >
          <ArrowLeft size={16} />
          Back to Dashboard
        </button>
        <button
          onClick={onViewAll}
          className="text-white bg-[#FBB033] px-4 py-2 rounded-md font-semibold"
        >
          View All Declined ({totalDeclined})
        </button>
      </div>

      {/* Who declined, as opposed to whose fault - the professional's own
          declines from the employee app (customer confirmed with a code). */}
      <div
        onClick={() => onDeclinedByEmployeeClick?.()}
        className="cursor-pointer rounded-2xl p-5 flex items-center justify-between shadow-lg hover:scale-[1.02] transition bg-amber-100"
      >
        <div className="flex flex-col gap-1">
          <span className="text-sm font-semibold text-amber-700">
            Declined by professional
          </span>
          <span className="text-xs text-amber-700/80">
            Declined from the employee app, confirmed with the customer's code
          </span>
        </div>
        <span className="text-[#39354E] text-2xl font-bold">
          {declinedByEmployeeCount}
        </span>
      </div>

      <h2 className="text-white text-lg font-bold">
        Declined Bookings by Category
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {Object.entries(DECLINE_CATEGORY_LABELS).map(([value, label]) => {
          const count = declineCategoryCounts[value];
          if (count === undefined) return null;
          const styles = CATEGORY_STYLES[value] || CATEGORY_STYLES.UNSPECIFIED;
          return (
            <div
              key={value}
              onClick={() => onCategoryClick?.(value)}
              className={`cursor-pointer rounded-2xl p-5 flex flex-col gap-2 shadow-lg hover:scale-105 transition ${styles.bg}`}
            >
              <span className={`text-sm font-semibold ${styles.color}`}>
                {label}
              </span>
              <span className="text-[#39354E] text-2xl font-bold">
                {count}
              </span>
            </div>
          );
        })}

        {totalDeclined === 0 && (
          <div className="text-gray-400 col-span-full">
            No declined bookings found for the selected filters.
          </div>
        )}
      </div>
    </div>
  );
};

export default DeclineBreakdownCards;
